<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
<div class="card text-center" >
    <div class="card-header bg-primary text-left text-white font-weight-bold">
        Opportunity Listing Pending for SPRA Request
    </div>
    <div class="card-body">
        <mat-card >
            <mat-card-title class="font-weight-bold caption-color text-left">ENQUIRY LIST WITH SALE CODE</mat-card-title>
            <mat-divider></mat-divider>
            <mat-card-content class="pt-2" >        
                <table class="table" *ngFor="let item of WithSaleCode ; let i = index;">
                    <tr >
                        <td align="left" valign="top" width="100%">
                            <u>ORDER - {{i+1}} -
                                   {{item.Company}} -({{item.SaleCode}})
                            </u>
                        </td>
                        
                    </tr>
                    <tr >
                        <td align="left" valign="top" width="100%">
                         
                                <table width="100%" cellpadding="1" cellspacing="1" border="0">
                                    <thead>
                                    <tr class="rowhead">
                                        <td width="5%" align="center" valign="top">SNo.
                                        </td>
                                        <td width="15%" align="left">Product
                                        </td>
                                        <td width="15%" align="left">Segment
                                        </td>
                                        <td width="15%" align="right">Quantity
                                        </td>
                                        <td width="20%" align="right">Unit Price (Rs.)
                                        </td>
                                        <td width="10%" align="right">Total (Rs.)
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="row1" *ngFor="let product of WithSaleCode[i].ProductDetails ; let j = index;" >
                                        <td width="5%" align="center" valign="top">
                                            {{j+1}}
                                        </td>
                                        <td width="15%" align="left">
                                              {{product.PartCode}}
                                        </td>
                                        <td width="15%" align="left">
                                            {{product.MakeCode}}
                                        </td>
                                        <td width="15%" align="right">
                                            {{product.Units}}
                                        </td>
                                        <td width="20%" align="right">
                                            {{product.Rate}}
                                        </td>
                                        <td width="10%" align="right">
                                         {{product.Units*product.Rate}}
                                        </td>
                                    </tr>
                                </tbody>
                                
                                    </table>
                           
                        </td>
                        
                    </tr>
                    <tr>
                        <td align="right" valign="top" width="100%" class="btn-link text-primary">
                            <span (click)="OnMakeSPRA(item)">Make SPRA</span>
                        </td>
                    </tr>
               </table>
               
        
            </mat-card-content>
        </mat-card>
    

    </div>

    <!-- With Out Sale code -->
    <div class="card-body">
        <mat-card >
            <mat-card-title class="font-weight-bold caption-color text-left">ENQUIRY LIST WITH OUT SALE CODE</mat-card-title>
            <mat-divider></mat-divider>
            <mat-card-content class="pt-2" >        
                <table class="table" #table *ngFor="let item of WithoutSaleCode ; let i = index;" >
                    <tr >
                        <td align="left" valign="top" width="100%">
                            <u>ORDER - {{i+1}} -
                                   {{item.Company}} 
                            </u>
                          
                           
                        </td>
                        
                    </tr>
                    <tr >
                        <td align="left" valign="top" width="100%">
                         
                                <table width="100%" cellpadding="1" cellspacing="1" border="0">
                                    <thead>
                                    <tr class="rowhead">
                                        <td width="5%" align="center" valign="top">SNo.
                                        </td>
                                        <td width="15%" align="left">Product
                                        </td>
                                        <td width="15%" align="left">Segment
                                        </td>
                                        <td width="15%" align="right">Quantity
                                        </td>
                                        <td width="20%" align="right">Unit Price (Rs.)
                                        </td>
                                        <td width="10%" align="right">Total (Rs.)
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="row1" *ngFor="let product of WithoutSaleCode[i].ProductDetails ; let j = index;" >
                                        <td width="5%" align="center" valign="top">
                                            {{j+1}}
                                        </td>
                                        <td width="15%" align="left">
                                              {{product.PartCode}}
                                        </td>
                                        <td width="15%" align="left">
                                            {{product.MakeCode}}
                                        </td>
                                        <td width="15%" align="right">
                                            {{product.Units}}
                                        </td>
                                        <td width="20%" align="right">
                                            {{product.Rate}}
                                        </td>
                                        <td width="10%" align="right">
                                         {{product.Units*product.Rate}}
                                        </td>
                                    </tr>
                                </tbody>
                                
                                    </table>
                           
                        </td>
                        
                    </tr>
                    <tr >
                        
                        <td align="right" valign="top" width="100%" class="btn-link text-primary" >
                            
                            <span (click)="OnCreateNewContact(item)">Create New Contact</span>
                        </td>
                    </tr>
               </table>
               
        
            </mat-card-content>
        </mat-card>
    

    </div>


  </div>


  